export const MAX_PERSONALIZATON_CHAR = 30;
